import { useEffect, useState } from 'react';

import { EBlockType, IBlock } from 'detailsv2/__blocks';
import { isNotDefined } from 'utils/ramda';

import { useBlockContext } from '../../../Block/context';

export const useMoreDetails = () => {
  const { block } = useBlockContext<IBlock<EBlockType.MoreDetails>>();
  const [showDetails, setShowDetails] = useState(!block.data.isCollapsible);
  const isDisabled = isNotDefined(block.children);

  useEffect(() => {
    if (isDisabled) {
      setShowDetails(true);
    }
  }, [isDisabled]);

  return { showDetails, setShowDetails, isDisabled };
};
